module.exports = __webpack_public_path__ + "static/media/Portal_Logo.9aead086.svg";